import { jsx as t, jsxs as r } from "react/jsx-runtime";
import "react";
import m from "../Image/index.js";
import x from "../Container/index.js";
const f = _ref => {
    let {
      image: e,
      imageClass: a,
      heading: s,
      headingClass: c,
      content: l,
      contentWrapperClass: o,
      contentClass: d,
      className: i,
      children: n,
      ...h
    } = _ref;
    return /* @__PURE__ */t("div", {
      className: `sash-HeroVertical relative bg-black ${i || ""}`,
      "data-testid": "hero-vertical",
      ...h,
      children: /* @__PURE__ */r(x, {
        className: "relative md:flex",
        noPadding: !0,
        children: [(e == null ? void 0 : e.src) && /* @__PURE__ */t("div", {
          className: "md:flex-1",
          children: /* @__PURE__ */t(m, {
            src: e.src,
            srcSet: e.srcSet,
            sizes: e.sizes,
            alt: e.alt || "",
            className: `sash-HeroImage block aspect-[3/2] w-full md:h-full ${a || ""}`,
            loading: "eager"
          })
        }), /* @__PURE__ */r("div", {
          className: `sash-HeroContent flex flex-col justify-center px-6 py-4 md:w-[37%] md:px-8 md:py-5 xl:w-4/12 xl:px-10 ${o || ""}`,
          children: [s && /* @__PURE__ */t("h1", {
            className: `sash-HeroHeading mb-3 text-white [&_a]:text-white ${c || ""}`,
            dangerouslySetInnerHTML: {
              __html: s
            }
          }), l && /* @__PURE__ */t("div", {
            className: `sash-HeroDesc text-subtitle font-bold text-white [&_a]:text-white ${d || ""}`,
            dangerouslySetInnerHTML: {
              __html: l
            }
          }), n]
        })]
      })
    });
  },
  w = f;
export { w as default };